import {Injectable} from '@angular/core';
import {applicationUrls} from "../../../shared/application-constants/application-urls.const";
import {HttpClient, HttpErrorResponse, HttpParams} from "@angular/common/http";
import {Observable, of, throwError} from "rxjs";
import {ActivityLogView, PageResponse, SearchCriteria} from "../../stp-operations/services/stp-activity-log.service";
import {catchError} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AuthActivityLogService {


  private apiUrl = applicationUrls;

  constructor(private httpClient: HttpClient) {
  }


  private handleError<T>(operation?: string, result?: T) {
    return (error: HttpErrorResponse): Observable<T> => {
      console.error(`${operation} failed: ${error.message}`);
      return throwError(() => new Error(error.message || 'An unknown error occurred'));
    };
  }


  getAuthActivityLog(criteria: SearchCriteria) {
    const pageIndex = Math.max(criteria.page - 1, 0);
    const params = new HttpParams()
      .set('username', criteria.username || '')
      .set('operation', criteria.operation || '')
      .set('startDate', criteria.startDate || '')
      .set('endDate', criteria.endDate || '')
      .set('page', pageIndex.toString())
      .set('size', criteria.size.toString());

    return this.httpClient
      .get<PageResponse<ActivityLogView>>(this.apiUrl.activityLog.authLog, {params})
      .pipe(
        catchError(err => {
          console.error('getAuthActivityLog error', err);
          return of({content: [], totalElements: 0, size: criteria.size, number: pageIndex});
        })
      );
  }

}
